import React, { useState, useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Functions from '../../api/Functions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import M from 'materialize-css';
import { firestoreConnect } from 'react-redux-firebase';
const refModal = React.createRef();

function WeeklyMissionsMenu(props) {
  const { weeklyMission } = props;
  const [loading, setLoading] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState({ text: '', action: null });
  const [activeWeeklyMission, setActiveWeeklyMission] = useState(null);

  useEffect(() => {
    let elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  }, []);

  useEffect(() => {
    if (!weeklyMission) return;
    const missions = [];
    for (var key in weeklyMission) missions.push({ id: key, ...weeklyMission[key] });
    if (missions.length > 0) setActiveWeeklyMission(missions[0]);
  }, [weeklyMission]);

  const manuallyDoAutomaticAssignment = () => {
    setConfirmationDialog({ text: '', action: null });
    setLoading(true);
    Functions.manuallyDoAutomaticWeeklyMissionAssignment()
      .then(() => M.toast({ html: 'Finished execution' }))
      .catch((e) => M.toast({ html: e.message ? e.message : 'Something went wrong' }))
      .finally(() => setLoading(false));
  };

  const assignMissionToAllUsers = () => {
    if (!activeWeeklyMission) return;
    setConfirmationDialog({ text: '', action: null });
    setLoading(true);
    Functions.assignWeeklyMissionToUserIds(activeWeeklyMission.id)
      .then(() => M.toast({ html: 'Finished execution' }))
      .catch((e) => M.toast({ html: e.message ? e.message : 'Something went wrong' }))
      .finally(() => setLoading(false));
  };

  const renderConfirmDialog = () => {
    return (
      <div ref={refModal} id="modal1" className="modal">
        <div className="modal-content">
          <p>{confirmationDialog.text}</p>
        </div>
        <div className="modal-footer">
          <a href="#!" onClick={(e) => confirmationDialog.action()} className="modal-close waves-effect btn btn-flat">
            Confirm
          </a>
          <a href="#close" className="modal-close waves-effect btn btn-flat">
            Cancel
          </a>
        </div>
      </div>
    );
  };

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  return (
    <div className="container">
      {renderConfirmDialog()}
      <div className="title-section">Weekly Mission Menu</div>
      <div className="row">
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Weekly Missions</p>
              </div>
              <div className="card-action">
                <Link to="weeklyMissions">Weekly Missions</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Repeat weekly automatic assignment</p>
              </div>
              <div className="card-action">
                <Link
                  to={window.location}
                  onClick={() => {
                    setConfirmationDialog({ text: 'Are you sure? This action will repeat the weekly automatic assignment of Weekly Mission to all users', action: manuallyDoAutomaticAssignment });
                    M.Modal.getInstance(refModal.current).open();
                  }}>
                  Assign to all users
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Re-assign Weekly Mission to all users</p>
              </div>
              <div className="card-action">
                <Link
                  to={window.location}
                  onClick={() => {
                    setConfirmationDialog({ text: 'Are you sure? This action will re-assign the active Weekly Mission to all users', action: assignMissionToAllUsers });
                    M.Modal.getInstance(refModal.current).open();
                  }}>
                  Re-assign to all users
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Verify user mission</p>
              </div>
              <div className="card-action">
                <Link to="verifyUserMission">
                  Verify user mission
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading && <h5>Executing...</h5>}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    weeklyMission: state.firestore.data['weeklyMission'],
    auth: state.firebase.auth,
  };
};

export default compose(
  firestoreConnect([
    {
      collection: 'weeklyMission',
      where: ['activated', '==', true],
      storeAs: 'weeklyMission',
    },
  ]),
  connect(mapStateToProps),
)(WeeklyMissionsMenu);
